import React, { createRef } from 'react';
import { IonAlert, IonLoading, IonChip, IonCard, IonActionSheet, IonButtons, IonFab, IonFabButton, IonIcon, IonContent, IonHeader, IonItem, IonLabel, IonList, IonPage, IonTitle, IonToolbar, withIonLifeCycle } from '@ionic/react';
import { checkmarkCircle, star, volumeHigh, barbell, removeCircle, time, checkmarkDoneCircle, checkmarkDone } from 'ionicons/icons'
import { close, timer, shuffle, options } from 'ionicons/icons'
import '../styles/Queue.scss';
import Storage from '../Storage';
import Utilities from '../Utilities';
import SQLStorage from '../SQLStorage';
import { createGesture, Gesture } from '@ionic/react';
import NotificationsImg from '../images/notifications-2.png';
import LogoImg from '../images/icon.png';
import FlashcardEditModal from './FlashcardEditModal';

import store from '../state/store';
import { updatedSetsSet } from '../state/actions/UpdatedSets';

import { LocalNotifications } from '@capacitor/local-notifications';
import { Device } from '@capacitor/device';

const NOTIFICATION_SCHEDULE = {
    "2": [8, 16],
    "3": [8, 19],
    "4": [8, 22],
    "5": [17, 19],
    "6": [17, 22]
}

let TOTAL_NOTIFICATIONS = 50;

class Queue extends React.Component {

    constructor(props) {
        super(props);
        this.timer = null;
        this.schedulePreviewInterval = null;
        this.scheduledWebNotifications = [];
        this.state = {
            status: window.ln.loading,
            words: [],
            cards: null,
            queue: null,
            type: '1',
            frequency: '5',
            schedule: '1',
            notifications: null,
            tags: [],
            strengthSettingCardId: null,
            oneSecondRefresher: "",
            openCardI: null,
            alreadyReviewedInThisRound: [],
        };
    }

    async load() {

        let lastFrequency = await Storage.getO("lastFrequency");
        let lastType = await Storage.getO("lastType");

        let lastPractice = await Storage.getO("lastPractice");
        let cards = [];
        let studyset;
        let setsRedux;

        if (lastPractice && lastPractice.type === "notifications") {

            let currentCard = 0;

            if (!lastPractice.cardIds || lastPractice.cardIds.length === 0) {

                if (lastPractice.content === "due") {
                    cards = await SQLStorage.getDueCards(Utilities.timestamp());
                } else if (lastPractice.content === "new") {
                    cards = await SQLStorage.getNewCards();
                } else if (lastPractice.content === "mastered" || lastPractice.content === "learnt" || lastPractice.content === "studying") {
                    cards = await SQLStorage.getCardsByStregth(lastPractice.content === "mastered" ? 5 : lastPractice.content === "learnt" ? 3 : 1 );
                } else {
                    cards = await SQLStorage.getAllCardsFromStudyset(lastPractice.content === "custom" ? null : lastPractice.content, "lastReviewed", "ASC");
                    cards = Utilities.filterForPractice(cards, lastPractice.filters.filter(f => !f.startsWith("keywords:")), lastPractice.filters.find(f => f.startsWith("keywords:")) ? lastPractice.filters.find(f => f.startsWith("keywords:")).replace("keywords:", "") : null);
                    studyset = await SQLStorage.getStudyset(lastPractice.content === "custom" ? cards[0].setId : lastPractice.content);
                    if (!studyset) {
                        store.dispatch(updatedSetsSet(['null'])); await Storage.remove("lastPractice"); window.toast(window.ln.setNotFound, "error"); this.props.history.goBack(); this.setState({ fullscreenLoading: false }); return;
                    }
                }

                if (lastPractice && lastPractice.total !== lastPractice.chunk) {
                    cards = cards.slice(0 + lastPractice.chunkI * lastPractice.chunk, (0 + lastPractice.chunkI * lastPractice.chunk) + lastPractice.chunk)
                }

            } else {

                cards = await SQLStorage.getCardsByIds(lastPractice.cardIds, true);
                currentCard = lastPractice.currentCard;

            }

            if (cards.length < 1) {
                store.dispatch(updatedSetsSet(['null'])); await Storage.remove("lastPractice"); window.toast(window.ln.notEnoughCards, "error"); this.props.history.goBack(); this.setState({ fullscreenLoading: false }); return;
            }

            if (!studyset) {
                setsRedux = store.getState().calendar.studysets;
                if (!setsRedux) {
                    setTimeout(function() { this.load() }.bind(this), 100);
                    return;
                }
            }

            if (studyset) {
                for (let i = 0; i < cards.length; i++) {
                    if (lastPractice.content === "custom") {
                        studyset = store.getState().calendar.studysets[cards[i].setId];
                    }
                    cards[i].setTerm = studyset.term || "";
                    cards[i].setDefinition = studyset.definition || "";
                }
            } else {
                for (let i = 0; i < cards.length; i++) {
                    cards[i].setTerm = (setsRedux[cards[i].setId] && setsRedux[cards[i].setId].term) ? setsRedux[cards[i].setId].term : ""
                    cards[i].setDefinition = (setsRedux[cards[i].setId] && setsRedux[cards[i].setId].definition) ? setsRedux[cards[i].setId].definition : ""
                }
            }

            this.setState({
                details: studyset,
                cards: cards,
                originalCardsLength: cards.length,
                tags: store.getState().calendar.tags || [],
                currentCard: currentCard,
                fullscreenLoading: false,
                frequency: (!lastFrequency || lastFrequency === 'off') ? '5' : lastFrequency,
                type: lastType || '1',
                practiceConfig: lastPractice,
            }, function() {
                Utilities.trackEvent("Queue", "Queue Practice Start", lastPractice.content, currentCard);
                this.reschedule();
                if (!lastPractice.cardIds || lastPractice.cardIds.length === 0) {
                    let practiceConfig = this.state.practiceConfig;
                    practiceConfig.cardIds = this.state.cards.map(item => item.id);
                    this.setState({ practiceConfig: practiceConfig }, () => { this.savePracticeConfig() })
                }
            })

        } else {

            this.props.history.goBack();

        }

    }

    savePracticeConfig = async () => {
        let lastPractice = await Storage.getO("lastPractice");
        if (lastPractice) {
            let practiceConfig = this.state.practiceConfig;
            practiceConfig.currentCard = this.state.currentCard;
            Storage.setO("lastPractice", practiceConfig);
        }
    }

    async pronounceWord(term, definition) {

        console.log("PRONOUNCE", term, definition)

        if (this.state.termPronouncation)
            await Utilities.pronounceWord(term, this.state.details.term);

        if (this.state.definitionPronouncation)
            await Utilities.pronounceWord(definition, this.state.details.definition);

    }

    async ionViewDidEnter() {

        this.setState({ fullscreenLoading: true })

        // if (deviceInfo.platform === "web" && (!('Notification' in window))) {
        //     this.props.history.goBack();
        //     return;
        // }

        let permissionState = await LocalNotifications.checkPermissions();

        if (permissionState.display === "denied") {
            window.toast("Notifications were disabled, enable in settings", "error");
            return
        } else if (permissionState.display === "granted") {
        } else {
            permissionState = await LocalNotifications.requestPermissions();
            this.ionViewDidEnter();
            return;
        }

        this.load();

    }

    async ionViewWillEnter() {
        this.setState({ fullscreenLoading: true, })
    }

    setFrequency(frequency) {
        Utilities.trackEvent("Queue", "Queue Set Frequency", null, frequency);
        Storage.setO("lastFrequency", frequency);
        this.setState({ frequency: frequency });
        this.reschedule();
    }

    setType(type) {
        Utilities.trackEvent("Queue", "Queue Set Type", null, type);
        Storage.setO("lastType", type);
        this.setState({ type: type });
        this.reschedule();
    }

    async reschedule(reloadAll) {
        Utilities.trackEvent("Queue", "Queue Reschedule", null, null, true);

        this.setState({ fullscreenLoading: true })

        let newCards = JSON.parse(JSON.stringify(this.state.cards))
        
        if (window.os === "web") {
            this.scheduledWebNotifications.map(item => {
                clearTimeout(item);
                return null;
            });
            this.scheduledWebNotifications = [];
        } else {
            await Utilities.cancelPendingQueueNotifications();
        }

        if (this.state.frequency === "off") {
            this.setState({ fullscreenLoading: false })
            await Storage.remove("notifications");
            return;
        }

        let notifications = await Storage.getO("notifications");
        notifications = notifications || [];

        console.log("reschedule()", newCards, notifications);

        let now = new Date();
        let removedCount = 0;
        let alreadyReviewedInThisRound = this.state.alreadyReviewedInThisRound;

        // Removing expired notifications
        for (let i = 0; i < notifications.length; i++) {
            let not = notifications[i];
            let card = newCards.find(itemCard => itemCard.id === not.id);

            if (!card) {
                this.endPractice();
                return;
            }

            if (new Date(not.scheduledDate) <= now) {
                let card = await SQLStorage.getCardById(notifications[i].id);

                if (alreadyReviewedInThisRound.indexOf(card.id) === -1) {
                    console.log("@@@@ REVIEWING " + card.id)
                    alreadyReviewedInThisRound.push(card.id);
                    card.history.push("10_n_" + Utilities.timestamp());
                    await SQLStorage.saveCard(card);
                    await window.dropbox.queueForUpload("card", card.id + "-" + card.setId);
                }
            }

            if (reloadAll) {
                notifications.splice(i, 1);
                i--;
                removedCount++;
            } 
        }

        // if (removedCount > 0) {
        //     newCards.splice(0, removedCount);
        // }

        // if (!window.activated) {
        //     TOTAL_NOTIFICATIONS = 10;
        // }

        // Filling to 50
        while (notifications.length < TOTAL_NOTIFICATIONS) {
            if (newCards[notifications.length]) {
                notifications.push(newCards[notifications.length])
            } else {
                break;
            }
        }

        if (notifications.length === 0) {
            this.endPractice();
            return;
        }

        let frequency = this.state.frequency * 60;

        let notificationsToBeScheduled = [];
        let notificationsToBeScheduledRef = {}

        const NOWNOW = new Date();
        let alreadySentCount = 0;

        for (let i = 0; i < notifications.length; i++) {

            let not = notifications[i];

            if (new Date(not.scheduledDate) <= NOWNOW) {
                alreadySentCount++;
                continue;
            }

            now = Utilities.dateAdd(now, 'second', frequency);

            console.log("@@ Scheduling at " + now + " " + not.id + " " + not.term)

            not.scheduledDate = now;

            let title = "";
            let body = "";

            if (this.state.type === "1") {
                title = not.term || "";
                body = not.definition || "";
            } else if (this.state.type === "2") {
                title = not.term || "";
                if (not.definition)
                    body = "Hold to reveal definition\n\n\n\n" + not.definition
            } else if (this.state.type === "3") {
                title = not.definition || "";
                body = not.term || "";
            } else if (this.state.type === "4") {
                title = not.definition || "";
                if (not.term)
                    body = "Hold to reveal term\n\n\n\n" + not.term
            }

            if (title.length > 28) {
                body = title + "\n" + body
                title = "";
            }

            if (window.os === "web") {
                body = not.term + " -- means -- " + not.definition
            }

            notificationsToBeScheduled.push({
                title: title,
                body: body,
                id: i,
                schedule: { at: now },
                sound: 'default',
                attachments: null,
                actionTypeId: "",
                extra: null,
            })

            notificationsToBeScheduledRef[i] = not.id;

        }

        console.log("@@@ ALREADY SENT COUNT: " + alreadySentCount + " of " + notifications.length)

        if (notifications.length !== alreadySentCount) {
            now = Utilities.dateAdd(now, 'second', 2);

            notificationsToBeScheduled.push({
                title: window.ln.ranOutOfWordsShort,
                body: window.ln.ranOutOfWordsBody /*+ (window.activated) ? "" : window.ln.proIncreaseNotifications*/,
                id: 100,
                schedule: { at: now },
                sound: "default",
                attachments: null,
                actionTypeId: "",
                extra: null
            })
            
            if (window.os !== "web") {
                await LocalNotifications.schedule({ notifications: notificationsToBeScheduled });
            } else {
                // console.log("SCHEDULED FOR: ", new TimestampTrigger(notificationsToBeScheduled[0].schedule.at));
                for (let i = 0; i < notificationsToBeScheduled.length; i++) {
                    const not = notificationsToBeScheduled[i];
                    this.scheduledWebNotifications.push(setTimeout(function() {
                        console.log("RUNNING " + i + " " + not.schedule.at.getMinutes())
                        const nn = new Notification((i + 1) + ' out of ' + (notificationsToBeScheduled.length - 1) + ' cards', {
                            body: notificationsToBeScheduled[i].body,
                            icon: '/android-chrome-192x192.png'
                        });
                    }, Utilities.differenceBetweenDatesSeconds(new Date(), not.schedule.at) * 1000))

                    console.log("Scheduling in " +  Utilities.differenceBetweenDatesSeconds(new Date(), not.schedule.at))
                }
                console.log(this.scheduledWebNotifications);
            }

        }

        setTimeout(function() {
            localStorage.setItem("scheduledNotifications", JSON.stringify(notificationsToBeScheduledRef));
        }.bind(this), 1000);

        this.setState({ 
            notifications: notifications, 
            fullscreenLoading: false,
            practiceEndModal: (notifications.length === alreadySentCount),
            alreadyReviewedInThisRound: alreadyReviewedInThisRound
        })
        await Storage.setO("notifications", notifications);

    }

    refreshTimeForNotificationPreviews() {

        // practiceEndModal: (notifications.length === alreadySentCount),

        // console.log("@@@@ refreshTimeForNotificationPreviews()")

        let haveAnyUndelivered = false;
        if (this.state.notifications) {
            const NOW = new Date();
            for (let i = 0; i < this.state.notifications.length; i++) {
                if (new Date(this.state.notifications[i].scheduledDate) >= NOW) {
                    // console.log("@@@@ At least one tha tis not sent")
                    haveAnyUndelivered = true;
                    break;
                }
            }
        }

        this.setState({
            oneSecondRefresher: this.state.oneSecondRefresher === " " ? "" : " ",
            practiceEndModal: haveAnyUndelivered ? false : true
        })
    }

    componentWillUnmount() {
        window.removeEventListener("focus", this.handleFocus);
        clearInterval(this.schedulePreviewInterval);
    }

    async componentDidMount() {
        window.removeEventListener("focus", this.handleFocus);
        window.addEventListener("focus", this.handleFocus);

        let gesture = createGesture({ el: document.getElementById('queue-ion-page'), threshold: 0, gestureName: 'my-gesture', gesturePriority: 40.5, onMove: ev => {} });
        gesture.enable(true);

        clearInterval(this.schedulePreviewInterval)
        this.schedulePreviewInterval = setInterval(() => {
            this.refreshTimeForNotificationPreviews();
        }, 1000)
    }

    handleFocus = () => {
        if (this.state.cards && window.location.href.indexOf("/queue") !== -1)
            this.reschedule();
    }

    repeatThisChunk = async () => {
        Utilities.trackEvent("Queue", "Queue Repeat this Round");
        this.setState({
            alreadyReviewedInThisRound: []
        }, () => {
            this.reschedule(true);
        })
    }

    loadNextChunk = async () => {
        Utilities.trackEvent("Queue", "Queue Load next Round");
        await Utilities.cancelPendingQueueNotifications();
        await Storage.remove("notifications");
        store.dispatch(updatedSetsSet([...new Set(this.state.cards.map(c => c.setId))]))
        let practiceConfig = this.state.practiceConfig;
        practiceConfig.cardIds = [];
        this.setState({
            notifications: [],
            alreadyReviewedInThisRound: [],
            practiceConfig : practiceConfig
        }, async () => {
            await this.savePracticeConfig();
            this.load();
        })
    }

    endPractice = async (continueLater) => {
        Utilities.trackEvent("Practice", "Queue Practice End", "Quiz", continueLater ? 1 : 0);

        if (continueLater === undefined) {
            this.setState({
                endPracticeConfirm: true
            })
        } else {
            this.setState({ fullscreenLoading: false })
            clearInterval(this.schedulePreviewInterval);
            if (!continueLater) {
                localStorage.setItem("justEndedPractice", "true");
                let a = await Storage.remove("lastPractice");
            }
            let b = Storage.remove("notifications");
            let c;
            if (window.os === "web") {
                this.scheduledWebNotifications.map(item => {
                    clearTimeout(item);
                    return null;
                });
                this.scheduledWebNotifications = [];
            } else {
                c = await Utilities.cancelPendingQueueNotifications();
            }
            store.dispatch(updatedSetsSet([...new Set(this.state.cards.map(c => c.setId))]))
            this.props.history.goBack();
            return c;
        }
    }

    async setMastered(i) {

        let cards = this.state.cards;
        let currentCard = cards[i];
        let oldStrength = currentCard.strength;

        if (oldStrength === 5) {
            return;
        }

        Utilities.trackEvent("Flashcard", "Master", currentCard.id + "|Queue");

        currentCard.strength = 5;
        currentCard.history.push("2_strength-" + oldStrength + "_" + Utilities.timestamp());
        currentCard.history.push("1_strength-" + 5 + "_" + Utilities.timestamp());
        cards[i] = currentCard

        await SQLStorage.saveCard(currentCard);
        await window.dropbox.queueForUpload("card", currentCard.id + "-" + currentCard.setId);
        this.setState({ cards: cards }, () => {
            this.review(i)
        })

    }

    review = async(i) => {
        let cards = this.state.cards;
        let notifications = this.state.notifications;
        const cardId = this.state.notifications[i].id
        console.log("Deleting notif", this.state.notifications[i].term)
        notifications.splice(i, 1);

        for (let j = 0; j < this.state.cards.length; j++) {
            if (this.state.cards[j].id === cardId) {
                const cardToBeReviewed = this.state.cards[j];
                console.log("@@@@ REVIEWING " + cardToBeReviewed.id)
                cardToBeReviewed.history.push("10_n_" + Utilities.timestamp());
                await SQLStorage.saveCard(cardToBeReviewed);
                await window.dropbox.queueForUpload("card", cardToBeReviewed.id + "-" + cardToBeReviewed.setId);
                cards.splice(j, 1);
                break;
            }
        }

        await Storage.setO("notifications", notifications);

        let practiceConfig = this.state.practiceConfig;
        practiceConfig.cardIds = cards.map(item => item.id);
        this.setState({ 
            cards: cards,
            practiceConfig: practiceConfig
        }, async () => {
            await this.savePracticeConfig();
            if (this.state.cards.length === 0) {
                this.loadNextChunk();
            } else {
                this.reschedule();
            }
        })
    }

    render() {

        return (
            <IonPage data-page="queue" id="queue-ion-page">
                <IonHeader>
                    <IonToolbar
                        style={{
                            '--background': window.dark ? "#181818" : "whitesmoke",
                        }}
                    >
                    </IonToolbar>
                </IonHeader>
                <IonContent data-onboarding="false">
                    <div className="background" data-full-height="true">
                    { (this.state.notifications && !this.state.practiceEndModal) &&
                        <div className="activities activities-compact">
                            <div data-activity="frequency" onClick={() => { this.setState({ frequencyActionSheet: true }) }}>
                                <IonIcon mode="ios" icon={timer} />
                                <div>
                                    <IonLabel>{window.ln.frequency}</IonLabel>
                                    <IonLabel>{{ "1": window.ln.tM1, "2": window.ln.tM2, "5": window.ln.tM5, "10": window.ln.tM10, "15": window.ln.tM15, "30": window.ln.tM30, "60": window.ln.tH1, "120": window.ln.tH2, "off": window.ln.off }[this.state.frequency]}</IonLabel>
                                </div>
                            </div>
                            <div data-activity="type" onClick={() => { this.setState({ typeActionSheet: true }) }}>
                                <IonIcon mode="ios" icon={options} />
                                <div>
                                    <IonLabel>{window.ln.mode}</IonLabel>
                                    <IonLabel>{["", window.ln.termPassive, window.ln.termActive, window.ln.defPassive, window.ln.defActive][this.state.type]}</IonLabel>
                                </div>
                            </div>
                            <div data-activity="close" onClick={() => { this.endPractice() }}>
                                <IonIcon mode="ios" icon={close} />
                                <div>
                                    <IonLabel>{window.ln.close}</IonLabel>
                                    <IonLabel>{window.ln.practice}</IonLabel>
                                </div>
                            </div>
                        </div>
                    }
                    <div 
                        className='notifications-list'
                        style={{
                            height: window.notchSizeBottom ? ('calc(100% - 76px - ' + window.notchSizeBottom + 'px)') : 'calc(100% - 88px)',
                            visibility: this.state.practiceEndModal ? "hidden" : "visible"
                        }}
                    >
                        <div className='info'>
                            { (this.state.notifications) &&
                                window.ln.notificationsScheduledInfo.replace("__", this.state.notifications.length)
                            }       
                        </div>
                        { (this.state.notifications) &&
                            <div className='notifications'>
                                { this.state.notifications.map((notif, i) => {
                                    const now = new Date();
                                    const scheduledFor = new Date(notif.scheduledDate);
                                    return (
                                        <div className='notif' onClick={() => {
                                            Utilities.onDrawerShow();
                                            this.setState({
                                                openCardI: i
                                            })
                                        }}>
                                            <label>
                                                { (now > scheduledFor) ?
                                                    <IonIcon icon={checkmarkCircle} />
                                                    :
                                                    (Utilities.toMMSS(Utilities.differenceBetweenDatesSeconds(scheduledFor, now)) + this.state.oneSecondRefresher).trim()
                                                }
                                            </label>
                                            <div className='notification-card'>
                                                <img src={LogoImg} />
                                                <div>
                                                    <p>{notif.term || "-"}</p>
                                                    <p>{notif.definition || "-"}</p>
                                                </div>
                                            </div>
                                            <IonIcon 
                                                icon={checkmarkDone} 
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    e.preventDefault();
                                                    this.setMastered(i);
                                                }}
                                            />
                                            <IonIcon 
                                                icon={close} 
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    e.preventDefault();
                                                    this.review(i);
                                                }}
                                            />
                                        </div>
                                    )
                                }) }
                            </div>
                        }
                        {/* <div className='img'>
                            <img src={NotificationsImg} />
                            <div className='button-wrapper'>
                                <button className='main' style={{ marginTop: 0 }} onClick={() => {
                                    this.loadNextChunk();
                                }}>{(window.ln.loadNextXCards).replace("__", this.state.practiceConfig ? this.state.practiceConfig.chunk : 0)}</button>
                            </div>
                        </div> */}
                    </div>
                    {/* { (this.state.notifications && this.state.notifications.length > 0 && !window.activated) &&
                        <div className="not-activated-card" onClick={() => { window.showSubscriptionModal("notifications"); }}>
                            <h1>{window.ln.scheduledAlertsProT}</h1>
                            <p>{window.ln.scheduledAlertsProT}</p>
                            <button>{window.ln.seeFeatures}</button>
                        </div>
                    } */}
                    </div>
                </IonContent>
                <IonActionSheet
                    isOpen={this.state.frequencyActionSheet}
                    header={window.ln.frequency}
                    onDidDismiss={() => { this.setState({ frequencyActionSheet: false }) }}
                    buttons={[
                        { text: window.ln.off, handler: () => { this.setFrequency("off") } },
                        { text: window.ln.tM1, handler: () => { this.setFrequency("1") } },
                        { text: window.ln.tM2, handler: () => { this.setFrequency("2") } },
                        { text: window.ln.tM5, handler: () => { this.setFrequency("5") } },
                        { text: window.ln.tM10, handler: () => { this.setFrequency("10") } },
                        { text: window.ln.tM15, handler: () => { this.setFrequency("15") } },
                        { text: window.ln.tM30, handler: () => { this.setFrequency("30") } },
                        { text: window.ln.tH1, handler: () => { this.setFrequency("60") } },
                        { text: window.ln.tH2, handler: () => { this.setFrequency("120") } },
                    ]}
               />
               <IonActionSheet
                   isOpen={this.state.typeActionSheet}
                   header={window.ln.notificationType}
                   onDidDismiss={() => { this.setState({ typeActionSheet: false }) }}
                   buttons={[
                       { text: window.ln.termAndDef, handler: () => { this.setType("1") } },
                       { text: window.ln.termHoldDef, handler: () => { this.setType("2") } },
                       { text: window.ln.defAndTerm, handler: () => { this.setType("3") } },
                       { text: window.ln.defHoldTerm, handler: () => { this.setType("4") } },
                   ]}
              />
              <IonLoading
                  isOpen={this.state.fullscreenLoading}
                  message={window.ln.loading}
                  duration={2000}
              />
              { (this.state.openCardI !== null) &&
                <FlashcardEditModal
                    onNewTag={(tag) => { this.setState({ tags: [...this.state.tags, tag] }) }}
                    open={this.state.notifications[this.state.openCardI].id}
                    flashcard={this.state.notifications[this.state.openCardI]}
                    defaultTerm={window.ln.term}
                    defaultDefinition={window.ln.def}
                    tags={this.state.tags}
                    preventEdit={true}
                    updateTagReferences={(a, b) => { }}
                    onDelete={ async () => { }}
                    onClose={ async (changedCard) => {
                        if (changedCard) {
                            let notifications = this.state.notifications;
                            let cards = this.state.cards;
                            for (let i = 0; i < cards.length; i++) {
                                if (cards[i].id === changedCard.id) {
                                    cards[i] = JSON.parse(JSON.stringify(changedCard));
                                    break;
                                }
                            }
                            notifications[this.state.openCardI] = JSON.parse(JSON.stringify(changedCard))
                            this.setState({ notifications: notifications, cards: cards })
                            await Storage.setO("notifications", notifications);
                        }
                        this.setState({ openCardI: null, openCardNew: false })
                    }}
                    />
                }
                { (this.state.practiceEndModal) &&
                    <div className="queue-end">
                        <div className='practice-end-wrapper'>
                            <h2>{window.ln.practiceCompleted}</h2>
                            { this.state.practiceConfig &&
                                <button onClick={() => {
                                    this.loadNextChunk();
                                }}>{(window.ln.loadNextXCards).replace("__", "" /*this.state.practiceConfig.chunk*/)}</button>
                            }
                            { this.state.practiceConfig &&
                                <button onClick={() => {
                                    this.repeatThisChunk();
                                }}>
                                    {(window.ln.repeatPractice).replace("__", "" /*this.state.practiceConfig.chunk*/)}
                                </button>
                            }
                            <button onClick={ async () => {
                                this.endPractice();
                            }} >
                                {window.ln.closePractice}
                            </button>
                        </div>
                    </div>
                }
                <IonActionSheet
                    isOpen={this.state.endPracticeConfirm}
                    header={window.ln.deletePractice + "?"}
                    onDidDismiss={() => { this.setState({ endPracticeConfirm: false }) }}
                    buttons={[
                        {
                            text: window.ln.continueLater,
                            handler: () => { this.endPractice(true) }
                        },
                        {
                            text: window.ln.deletePractice,
                            handler: () => { this.endPractice(false) }
                        }
                    ]}
                />
            </IonPage>
        );
    }

};


export default withIonLifeCycle(Queue);
